import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "mx-6" }, null, -1)
const _hoisted_3 = { class: "w-full flex flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportsUpload = _resolveComponent("ReportsUpload")!
  const _component_ClinicsReportsFilter = _resolveComponent("ClinicsReportsFilter")!
  const _component_ClinicReportsHeader = _resolveComponent("ClinicReportsHeader")!
  const _component_ClinicReportsList = _resolveComponent("ClinicReportsList")!
  const _component_ClinicsReportsControls = _resolveComponent("ClinicsReportsControls")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isAtleastManager)
        ? (_openBlock(), _createBlock(_component_ReportsUpload, {
            key: 0,
            class: "mt-4 w-full flex justify-end"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ClinicsReportsFilter, {
        class: "pb-4 mt-4",
        onOnFilter: _ctx.onFilter,
        onOnDetailView: _ctx.onDetailView
      }, null, 8, ["onOnFilter", "onOnDetailView"])
    ]),
    _createVNode(_component_ClinicReportsHeader, {
      class: "px-6 mt-6 mb-3",
      isDetailView: _ctx.isDetailView,
      data: _ctx.pdfDataInput
    }, null, 8, ["isDetailView", "data"]),
    _createVNode(_component_ClinicReportsList, {
      class: "px-6 pb-2 mt-6",
      "filter-params": _ctx.filterParams,
      isDetailView: _ctx.isDetailView,
      onOnWorkers: _ctx.onWorkers
    }, null, 8, ["filter-params", "isDetailView", "onOnWorkers"]),
    (!_ctx.isDetailView)
      ? (_openBlock(), _createBlock(_component_ClinicsReportsControls, {
          key: 0,
          class: "pr-6 pb-8 mt-2",
          pdfData: _ctx.pdfDataInput
        }, null, 8, ["pdfData"]))
      : _createCommentVNode("", true)
  ]))
}